import { API_DASHBOARD } from '../consts/apiRoutes.consts'
import SERVICE_CONSTS from '../consts/services.consts'
import { api } from './base/api.service'

const {
  RESPONSE_BASIC_STRUCTURE,
  MESSAGES
} = SERVICE_CONSTS

/** @type {import("./dashboard.service.types")["getDashboardSummaryByDateRange"]} */
export const getDashboardSummaryByDateRange = async (startDate, endDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_DASHBOARD}/getDashboardSummaryByDateRange`, {
      dateRange: {
        startDate,
        endDate
      }
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./dashboard.service.types")["generateBillingChartByDateRange"]} */
export const generateBillingChartByDateRange = async (startDate, endDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_DASHBOARD}/generateBillingChartByDateRange`, {
      dateRange: {
        startDate,
        endDate
      }
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./dashboard.service.types")["generateHoursByClientChartByDateRange"]} */
export const generateHoursByClientChartByDateRange = async (startDate, endDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_DASHBOARD}/generateHoursByClientChartByDateRange`, {
      dateRange: {
        startDate,
        endDate
      }
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}
